module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "background": "#000"
    },
    attrs: {
      "element-loading-text": "影像加载中",
      "element-loading-background": "rgba(0, 0, 0, 0.8)"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.imgSee) + "\n")]), _vm._v(" "), _c('pops', {
    attrs: {
      "title": _vm.提示,
      "show": _vm.popShow,
      "width": "30%",
      "center": ""
    },
    on: {
      "close": _vm.closePop
    }
  }, [_c('span', {
    staticClass: "infos"
  }, [_vm._v("影像调阅失败，请返回重新调阅")]), _vm._v(" "), _c('el-button', {
    staticClass: "sure",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.closePop
    }
  }, [_vm._v("确 定")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-80be1582","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/base/imgView.vue
// module id = 586
// module chunks = 1 2 3 4 5 6 7 8